import { render, staticRenderFns } from "./customize_step4.vue?vue&type=template&id=b038d95a&scoped=true"
import script from "./customize_step4.vue?vue&type=script&lang=js"
export * from "./customize_step4.vue?vue&type=script&lang=js"
import style0 from "./customize_step4.vue?vue&type=style&index=0&id=b038d95a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b038d95a",
  null
  
)

export default component.exports